import React, { memo, useCallback, useMemo } from 'react';
import DataGrid from 'components/data-grid';
import { useFormGrid } from 'AurionCR/components/formV2';
import { GridConfig } from './grid-config';
import { Editor } from './editor';

interface Props {
  userPatientProfileSubscriptionID: string;
  onRefresh: () => void;
  className?: string;
}

export const GridUserPatientProfileSubscriptionActivities = memo<Props>(
  ({ userPatientProfileSubscriptionID, onRefresh, className }) => {
    const { grid, onGridHandle, editItemID, setEditItemID, onFormHandle } = useFormGrid('activity');

    const gridConfig = useMemo<any>(() => {
      return GridConfig({ userPatientProfileSubscriptionID });
    }, [userPatientProfileSubscriptionID]);

    const onClose = useCallback(() => setEditItemID(null), [setEditItemID]);

    const onFormHandleProxy = useCallback<typeof onFormHandle>(
      (action) => {
        switch (action.type) {
          case 'post':
          case 'delete': {
            onRefresh();
          }
        }
        return onFormHandle(action);
      },
      [onFormHandle, onRefresh],
    );

    return (
      <>
        <DataGrid className={className} ref={grid} onHandle={onGridHandle} config={gridConfig} />
        {editItemID && (
          <Editor
            userPatientProfileSubscriptionID={userPatientProfileSubscriptionID}
            itemID={editItemID}
            onClose={onClose}
            onFormHandle={onFormHandleProxy}
          />
        )}
      </>
    );
  },
);
